import { render, staticRenderFns } from "./LocusDetail.vue?vue&type=template&id=43c3be9c&scoped=true"
import script from "./LocusDetail.vue?vue&type=script&lang=js"
export * from "./LocusDetail.vue?vue&type=script&lang=js"
import style0 from "./LocusDetail.vue?vue&type=style&index=0&id=43c3be9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c3be9c",
  null
  
)

export default component.exports